.button {
  padding: 2px;
  margin: 2px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  border: none;
  cursor: pointer;
  background-color: var(--tuna-palette-action-hover);
  color: inherit;
}

.button--selected {
  background-color: var(--tuna-palette-action-selected);
  color: var(--tuna-palette-secondary-light);
}

.contents {
  display: contents;
}
